// extracted by mini-css-extract-plugin
export default {"search":"chat-search_search__mj9fC","disabled":"chat-search_disabled__MbZAg","icon":"chat-search_icon__AUWM0","input":"chat-search_input__lK1t+","clear":"chat-search_clear__Hh4Xk"};